//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.BoundaryMemberSet.js";
let d=[[[0,"ConcaveCorners",1,0],[0,"Corner1",0,"CAM.BoundaryTurnMemberCorner",0],[0,"Corner2",0,"CAM.BoundaryTurnMemberCorner",0],[0,"CustomFeed",0,"CAM.BoundaryTurnMemberFeed",0],[0,"Events",0,"CAM.BoundaryTurnMemberEvents",0],[0,"FineFinishCorner1",0,"CAM.BoundaryTurnMemberFineFinishCorner",0],[0,"FineFinishCorner2",0,"CAM.BoundaryTurnMemberFineFinishCorner",0],[0,"FineFinishOffset",0,"CAM.BoundaryTurnMemberFineFinishOffset",0],[0,"IgnoreFineFinishOffset",1,0],[0,"IgnoreMember",1,0],[0,"OffsetBuilder",0,"CAM.BoundaryTurnMemberOffset",0]],[],[]];
SPLM.CAM.BoundaryTurnMemberSet = class extends SPLM.CAM.BoundaryMemberSet{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.BoundaryTurnMemberSet";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.BoundaryTurnMemberSet.ConcaveCornersTypeValue = Object.freeze({
    "Extend" : "Extend", "ConnectLinear" : "ConnectLinear"});

export default SPLM;